import gsap from 'gsap';
import { useEffect, useRef } from 'react';

export function useParallaxScroll(cardsRef) {
    useEffect(() => {
        const cards = cardsRef.current.filter(Boolean);
        if (cards.length === 0) return;

        // Check if desktop on mount
        const isDesktop = window.innerWidth >= 1025;
        if (!isDesktop) return; // Exit early on mobile/tablet

        let ticking = false;
        let lastScrollY = 0;

        // Use requestAnimationFrame for smooth 60fps updates
        const updateParallax = () => {
            const scrollY = window.scrollY;

            // Only update if scroll position changed
            if (scrollY === lastScrollY) {
                ticking = false;
                return;
            }

            lastScrollY = scrollY;

            // Batch DOM updates for better performance
            cards.forEach((card, index) => {
                const columnIndex = index % 3;
                const speed = columnIndex === 0 ? 0.15 : columnIndex === 1 ? 0.25 : 0.35;
                const yOffset = scrollY * speed;

                // Use transform3d for GPU acceleration
                card.style.transform = `translate3d(0, -${yOffset}px, 0)`;
            });

            ticking = false;
        };

        const handleScroll = () => {
            // Throttle with requestAnimationFrame
            if (!ticking) {
                requestAnimationFrame(updateParallax);
                ticking = true;
            }
        };

        // Set initial will-change on mount
        cards.forEach(card => {
            card.style.willChange = 'transform';
            card.style.backfaceVisibility = 'hidden';
        });

        // Use passive listener for better scroll performance
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            // Cleanup
            cards.forEach(card => {
                card.style.transform = '';
                card.style.willChange = '';
                card.style.backfaceVisibility = '';
            });
        };
    }, [cardsRef]);
}
